export function isValidationDisabled() {
  if (typeof window === 'undefined') return false
  try {
    const urlDebug =
      new URLSearchParams(window.location.search).get('debug') === '1'
    const sessionDebug = sessionStorage.getItem('brite-debug') === '1'
    return urlDebug || sessionDebug
  } catch {
    return false
  }
}
